<template>
  <v-menu v-model="showFilterForm"
          :close-on-content-click="false"
          offset-y
          bottom
          :nudge-width="500">
    <template v-slot:activator="{on, attrs}">
      <v-btn title="Filter settings"
             outlined
             v-bind="attrs"
             v-on="on">
        <v-icon left>
          {{ dirty ? 'fas fa-filter' : 'fal fa-filter' }}
        </v-icon>
        {{ dirty ? 'Filtered' : 'Filter' }}
        <v-icon right>
          fas fa-caret-down
        </v-icon>
      </v-btn>
    </template>
    <v-form @submit.prevent="search"
            ref="filterForm">
      <v-card>
        <div class="d-flex">
          <v-spacer></v-spacer>
          <v-btn icon
                 rounded
                 @click.prevent="showFilterForm = false">
            <v-icon>
              fal fa-times
            </v-icon>
          </v-btn>
        </div>
        <v-card-text class="pt-0">

          <v-text-field v-model="form.name"
                        label="Name"
                        placeholder=" "
                        autocomplete="fake-content-name">
          </v-text-field>

          <v-text-field v-model="form.external_id"
                        label="Asset ID"
                        placeholder=" "
                        autocomplete="fake-asset-id">
          </v-text-field>

          <v-select v-model="form.type"
                    label="Content Type"
                    placeholder=" "
                    :items="types"
                    item-value="id"
                    item-text="name">
          </v-select>

          <v-autocomplete v-model="form.group"
                          label="Group with access"
                          placeholder=" "
                          :items="filteredGroups"
                          item-value="id"
                          item-text="name">
          </v-autocomplete>

          <v-autocomplete v-model="form.owner_id"
                          label="Owner"
                          placeholder=" "
                          :items="filteredUsers"
                          item-value="id"
                          item-text="name">
          </v-autocomplete>

          <v-row>
            <v-col cols="4">
              <v-select v-model="form.expires_at.range"
                        label="Expiration Date"
                        placeholder=" "
                        :items="dateRanges"
                        item-value="id"
                        item-text="name"
                        @change="updateExpiresAtDates">
              </v-select>
            </v-col>
            <v-col cols="4">
              <v-text-field v-model="form.expires_at.start"
                            label="From"
                            placeholder=" "
                            autocomplete="fake-date"
                            append-icon="fal fa-calendar">
              </v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field v-model="form.expires_at.end"
                            label="To"
                            placeholder=" "
                            autocomplete="fake-date"
                            append-icon="fal fa-calendar">
              </v-text-field>
            </v-col>
          </v-row>

          <v-select v-model="form.status"
                    label="Status"
                    placeholder=" "
                    :items="statuses"
                    item-value="id"
                    item-text="name">
          </v-select>

          <v-select v-model="form.is_internal_use_only"
                    label="For Internal Use Only"
                    placeholder=" "
                    :items="uses"
                    item-value="id"
                    item-text="name">
          </v-select>
        </v-card-text>
        <v-card-actions>
          <v-btn type="submit"
                 @click.prevent="search"
                 color="primary">
            Submit
          </v-btn>
          <v-btn @click.prevent="resetFilter">
            Reset
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-menu>
</template>
<script>
import {mapGetters} from 'vuex';
import dataService from '../../../../../ml/services/dataService';
import presentationService from '../../../../../ml/services/presentationService';
import clone from 'lodash/clone';
import find from 'lodash/find';
import isEqual from 'lodash/isEqual';
import moment from 'moment-timezone';

export default {
  props: {
    form: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dateRanges: [
        {id: '', name: 'All'},
        {id: 'today', name: 'Today', start: moment().startOf('day'), end: moment().endOf('day')},
        {id: 'tomorrow', name: 'Tomorrow', start: moment().add(1, 'day').startOf('day'), end: moment().add(1, 'day').endOf('day')},
        {id: 'this_week', name: 'This week', start: moment().startOf('week'), end: moment().endOf('week')},
        {id: 'this_month', name: 'This month', start: moment().startOf('month'), end: moment().endOf('month')},
        {id: 'this_quarter', name: 'This quarter', start: moment().startOf('quarter'), end: moment().endOf('quarter')},
        {id: 'this_year', name: 'This year', start: moment().startOf('year'), end: moment().endOf('year')},
        {id: 'next_week', name: 'Next week', start: moment().add(1, 'week').startOf('week'), end: moment().add(1, 'week').endOf('week')},
        {id: 'next_month', name: 'Next month', start: moment().add(1, 'month').startOf('month'), end: moment().add(1, 'month').endOf('month')},
        {id: 'next_quarter', name: 'Next quarter', start: moment().add(1, 'quarter').startOf('quarter'), end: moment().add(1, 'quarter').endOf('quarter')},
        {id: 'next_year', name: 'Next year', start: moment().add(1, 'year').startOf('year'), end: moment().add(1, 'year').endOf('year')},
      ],
      dirty: false,
      roles: dataService.teamRoles('Any'),
      showFilterForm: false,
      statuses: dataService.presentationStatusCodes('Any'),
      types: presentationService.getTypes('Any'),
      uses: [
        {id: '', name: 'Either'},
        {id: true, name: 'For internal use only'},
        {id: false, name: 'Can be shown to customers'},
      ]
    }
  },
  computed: {
    ...mapGetters([
      'folders',
      'groups',
      'users',
    ]),

    filteredGroups() {
      let groups = clone(this.groups);
      groups.unshift({id: '', name: 'Any'});
      return groups;
    },
    filteredUsers() {
      let users = clone(this.users);
      users.unshift({id: '', name: 'Any'});
      return users;
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    isDirty() { // @see https://github.com/cretueusebiu/vform/issues/102
      return !isEqual(this.form.data(), this.form.originalData);
    },
    fetchData() {

    },
    resetFilter() {
      this.form.reset();
      this.$refs.filterForm.resetValidation();
      this.showFilterForm = false;
      this.dirty = false;
      this.$emit('search');
    },
    search() {
      this.dirty = this.isDirty();
      this.$emit('search')
      this.showFilterForm = false;
    },
    updateExpiresAtDates() {
      const dateRange = find(this.dateRanges, r => r.id === this.form.expires_at.range);
      console.log(dateRange);
      if (dateRange && dateRange.id) {
        this.form.expires_at.start = dateRange.start.format('YYYY-MM-DD');
        this.form.expires_at.end = dateRange.end.format('YYYY-MM-DD');
      } else {
        this.form.expires_at.start = '';
        this.form.expires_at.end = '';
      }
    }
  }
}
</script>
